export enum WeekDay {
Monday,
Tuesday,
Wendesday,
Thursday,
Friday,
Saturday,
Sunday,
}
